export const ONBOARDING_STORAGE_KEY = "asr-onboarding-v1";

/** Clears persisted self-serve onboarding wizard state for the current tab. */
export function clearOnboardingState(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(ONBOARDING_STORAGE_KEY);
}
